'use strict';

(function (global) {

  // Селекторы для объектов.
  const wordDocumentSelector = {
    commentArea: '.word-document-page__comments',
    deletedText: 'del',
    insertedText: 'ins',
  };

  // Доступные способы масштабирования области предпросмотра
  const PREVIEW_SCALE = {
    FIT_WIDTH: 'w',
  };

  /**
   * Действия над документом MS Word.
   * (Отображение комментариев и изменений)
   */
  class WordDocumentActions extends global.TextActions {

    constructor(context) {
      super(context);
    }

    /**
     * Включить отображение изменений.
     *
     * @function Core.preview.actions.enableTrackChanges
     */
    enableTrackChanges() {
      this._jFrameContents.find(wordDocumentSelector.insertedText).addClass('ins_highlighted');
      this._jFrameContents.find(wordDocumentSelector.deletedText).show();

      Core.preview.actions.settings.trackChangesVisibility = true;
    }

    /**
     * Отключить отображение изменений.
     *
     * @function Core.preview.actions.disableTrackChanges
     */
    disableTrackChanges() {
      this._jFrameContents.find(wordDocumentSelector.insertedText).removeClass('ins_highlighted');
      this._jFrameContents.find(wordDocumentSelector.deletedText).hide();

      Core.preview.actions.settings.trackChangesVisibility = false;
    }

    /**
     * Включить отображение комментариев.
     *
     * @function Core.preview.actions.enableComments
     * @param {boolean} [shouldMovePreview = true] Необходимость перерасчета и перемещения документа в центр.
     */
    enableComments(shouldMovePreview = true) {
      // Найдем все области комментариев и отобразим их
      this._jFrameContents.find(wordDocumentSelector.commentArea).show();
      Core.preview.actions.settings.commentsVisibility = true;

      if (shouldMovePreview) {
        this._moveOrScalePreview();
      }
    }

    /**
     * Выключить отображение комментариев.
     *
     * @function Core.preview.actions.disableComments
     * @param {boolean} [shouldMovePreview = true] Необходимость перерасчета и перемещения документа в центр.
     */
    disableComments(shouldMovePreview = true) {
      // Найдем все области комментариев и скроем их
      this._jFrameContents.find(wordDocumentSelector.commentArea).hide();
      Core.preview.actions.settings.commentsVisibility = false;

      if (shouldMovePreview) {
        this._moveOrScalePreview();
      }
    }

    /**
     * Сдвинуть или смасштабировать область предпросмотра.
     *
     * @function Core.preview.actions._moveOrScalePreview
     * @private
     * @since 5.7.0
     */
    _moveOrScalePreview() {
      if (Core.preview.actions.settings.previewScale === PREVIEW_SCALE.FIT_WIDTH) {
        Core.preview.actions.setScale();
      } else {
        Core.preview.actions.movePreview();
      }
    }

    /**
     * @see BaseActions.printDocFromPreview
     */
    printDocFromPreview() { 
      const iframe = window.frames.contentContainer;
      iframe.focus();
      if (iframe.document) {
        iframe.document.execCommand('print', false, null);
      } else {
        const tmpWindow = window.open('', 'PRINT', '');
        const contentDoc = $('#contentContainer').get(0).contentDocument;
        // Сформировать html для печати
        const jBody = contentDoc.body;

        $('img', jBody).each((index, img) => {
          img.setAttribute('src', img.src);
        });

        // подвинем к левому верхнему углу
        const customHTML = `
        <html lang="ru">
          <head>
            <link rel="stylesheet" type="text/css" href="/css/preview_print.css" />
            <link rel="stylesheet" type="text/css" href="/css/wait-page.css" />
            <script type="text/javascript">
              window.onload = function() { 
                window.print();
                ${!this._isIpad && !WA.ENV.isAndroid() ? 'window.close();' : ''}
              }
            </script>
          </head>
          <body>
            ${jBody.innerHTML}
          </body>
        </html>`;
        tmpWindow.document.write(customHTML);
        tmpWindow.document.close();
      }
    }
  }

  global.WordDocumentActions = WordDocumentActions;

})(window.Core.preview);